import { render, staticRenderFns } from "./InternalLetterId.vue?vue&type=template&id=547c5f08"
import script from "./InternalLetterId.vue?vue&type=script&lang=js"
export * from "./InternalLetterId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports